<template>
  <video muted autoplay playsinline loop>
    <source
      :src="video.fields.file.url"
      :type="video.fields.file.contentType"
    />
  </video>
</template>

<script>
export default {
  name: "CoreVideo",

  props: {
    video: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
